import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './index';
import { IndexConfigService } from './index.config.service';
import { LoginHelper } from '../helpers';
import { FixDates } from '../_decorators/date.decorator';
import { Load } from '../_decorators/loading.decorator';
import { AssessmentControlPatchRequest, AssessmentManagerUpsertRequest } from '../_models/assessmentManager';

@Injectable()
export class AssessmentManagerService {
  constructor(
    public http: HttpClient,
    public authenticationService: AuthenticationService,
    public config: IndexConfigService
  ) {}

  @FixDates()
  @Load()
  getProjectAssessments(projectId: number, years: number = 3) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return null;
    }

    return this.http.get<any>(this.config.api + `/api/projects/${projectId}/assessments?years=${years}`);
  }

  @FixDates()
  @Load()
  getAssessment(projectId: number, assessmentId: number) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return null;
    }

    return this.http.get<any>(this.config.api + `/api/projects/${projectId}/assessments/${assessmentId}`);
  }

  @FixDates()
  @Load()
  createAssessment(projectId: number, payload: AssessmentManagerUpsertRequest) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return null;
    }

    return this.http.post<any>(this.config.api + `/api/projects/${projectId}/assessments`, payload);
  }

  @FixDates()
  @Load()
  updateAssessment(projectId: number, assessmentId: number, payload: AssessmentManagerUpsertRequest) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return null;
    }

    return this.http.put<any>(this.config.api + `/api/projects/${projectId}/assessments/${assessmentId}`, payload);
  }

  @FixDates()
  @Load()
  updateAssessmentControl(assessmentControlId: number, payload: AssessmentControlPatchRequest) {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return null;
    }

    return this.http.patch<any>(this.config.api + `/api/assessmentControls/${assessmentControlId}`, payload);
  }
}
